// extracted by mini-css-extract-plugin
module.exports = {"container":"categoryRow_container__TvnTG","icon":"categoryRow_icon__GADmh"};